
import { mapState } from 'vuex'
export default {
  data: () => ({
    icons: ['mdi-facebook', 'mdi-twitter', 'mdi-linkedin', 'mdi-instagram'],
    isMounted:false,
  }),
  mounted(){
      this.isMounted=true
    },
  computed: {
    currentRouteName: {
      get() {
        return this.$route.path
      },
      set(newName) {
        return newName
      },
    },
    nextLnk() {
      switch (this.$route.path) {
        case '/feature':
          return '/property-manager-about'
        case '/property-manager-about':
          return '/owner-details'
        case '/owner-details':
          return '/residents'
        case '/residents':
          return '/recommend'
        case '/recommend':
          return '/pricing'
        case '/pricing':
          return '/contact'
        default:
          return 'dont-show'
      }
    },
  },
  computed: {
    ...mapState('config/site', ['siteConfig']),

  },
  watch: {
    '$route.path': {
      handler(val) {
        console.log(this.$route)
        this.currentRouteName = val
      },
      deep: true,
    },
  },
}
